module.exports = __webpack_public_path__ + "cda7a2a98814901f262a9df74f4a904c.png";